export class TagModel {
    public date: string;
    public unit: string;
    public value: number;
    public tagType: number;
    public isValueChanged: boolean;
}